import React, { FC } from 'react'

const ThumbnailsDownIcon: FC = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="15"
      cy="15"
      r="14.5"
      transform="rotate(-90 15 15)"
      fill="white"
      stroke="#E5E5EA"
    />
    <path
      d="M12.8504 13.4012L15 15.5501L17.1496 13.4012C17.5157 13.0351 18.1093 13.0351 18.4754 13.4012C18.8415 13.7673 18.8415 14.3609 18.4754 14.727L15.6629 17.5395C15.5221 17.6804 15.3476 17.767 15.1654 17.7995L15.0553 17.8125L14.9447 17.8125C14.7235 17.7995 14.5061 17.7085 14.3371 17.5395L11.5246 14.727C11.1585 14.3609 11.1585 13.7673 11.5246 13.4012C11.8907 13.0351 12.4843 13.0351 12.8504 13.4012Z"
      fill="#8E8E93"
    />
  </svg>

)

export default ThumbnailsDownIcon
